import e from"styled-components";const o=e.div`
	display: flex;
	align-items: center;
	gap: 8px;
	border-radius: 8px;
	padding-inline: 8px;
	cursor: pointer;

	transition: background-color 0.2s ease-in-out;

	&:hover {
		background-color: ${({theme:e})=>e.bg.secondary};
	}

	&:active {
		background-color: ${({theme:e})=>e.bg.hover};
	}
`,t=e.span`
	color: ${({theme:e})=>e.text.title};
	text-align: center;
	font-family: "PP Formula";
	font-size: 13px;
	font-style: normal;
	font-weight: 500;
	line-height: 20px;
`;export{o as PaletteActionContainer,t as PaletteActionLabel};
